import { createIndex as publicCreateIndex, dropIndex as publicDropIndex, listIndexes as publicListIndexes, } from './data-v2-index-indexes.public';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
export const createIndex = createRESTModule(publicCreateIndex);
export const dropIndex = createRESTModule(publicDropIndex);
export const listIndexes = createRESTModule(publicListIndexes);
export { Order, Status, Environment } from './data-v2-index-indexes.universal';
//# sourceMappingURL=data-v2-index-indexes.context.js.map